import React from 'react'

type Props = {
    children: React.ReactNode | React.ReactNode[]
}

function BlankLayout({ children }: Props): React.ReactNode {
    return (
        <div className="flex flex-col justify-center items-center bg-white px-4 sm:px-8 md:px-16 max-w-screen-md mx-auto my-8 py-8 rounded-md">
            {children}
        </div>
    )
}

export default BlankLayout
